import { useCallback, useState } from 'react';
import { Button } from 'app/agriculture/components/Button/Button';
import { Popover } from 'app/agriculture/components/Popover/Popover';
import './AddNewButton.scss';
import { AddNewButtonContent } from 'app/agriculture/FarmMain/TopBar/components/AddNewButton/AddNewButtonContent';
import classNames from 'classnames';

interface AddNewButtonProps {
    className?: string;
}

export function AddNewButton({ className }: AddNewButtonProps) {
    const [open, setOpen] = useState(false);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleOpen = useCallback(() => {
        setOpen(true);
    }, []);

    return (
        <div className={classNames('AddNewButton__container', className)}>
            <Popover pixelOffset={24} open={open} onOpenChange={setOpen}>
                <Popover.Trigger>
                    <Button
                        onClick={handleOpen}
                        className="AddNewButton"
                        startIcon="add"
                        id="add-new-button"
                        text="Add New"
                    />
                </Popover.Trigger>
                <Popover.Content disablePadding>
                    <AddNewButtonContent handleClose={handleClose} />
                </Popover.Content>
            </Popover>
        </div>
    );
}
